// Geodesic polygon area & perimeter helpers using WGS84 ellipsoid approximation.
// Accurate enough for plots up to hundreds of hectares.

const R = 6378137; // WGS84 equatorial radius in metres
const toRad = (d) => (d * Math.PI) / 180;

/**
 * Geodesic area of a closed polygon defined by [lat, lng] points, in m².
 * Uses the spherical excess formula (Chamberlain/Duquette).
 */
export function polygonAreaSqm(points) {
  const n = points.length;
  if (n < 3) return 0;
  let area = 0;
  for (let i = 0; i < n; i++) {
    const [lat1, lng1] = points[i];
    const [lat2, lng2] = points[(i + 1) % n];
    area += toRad(lng2 - lng1) * (2 + Math.sin(toRad(lat1)) + Math.sin(toRad(lat2)));
  }
  return Math.abs((area * R * R) / 2);
}

/**
 * Haversine distance between two [lat, lng] points, in metres.
 */
export function haversineM(p1, p2) {
  const [lat1, lng1] = p1, [lat2, lng2] = p2;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/**
 * Perimeter of a closed polygon in metres.
 */
export function polygonPerimeterM(points) {
  const n = points.length;
  if (n < 2) return 0;
  let d = 0;
  for (let i = 0; i < n; i++) d += haversineM(points[i], points[(i + 1) % n]);
  return d;
}
